import React from 'react';
import { styled, useGlobalCSS } from '../../../stitches.config';

import Box from '../Box'
import TrackEvent from "../../../components/TrackEvent";
import { useWindowWidth } from "../../../helpers";
import { useStores } from "../../../helpers";

const Wrapper = styled("div", {
	padding: "0 0 40px",
	"@bp4": {
		marginTop: "-80px"
	},
	/* dodatkowe style do embedów które zmieniają się w photoOnTop na mobile */
	".photo-on-top-embed": {
		padding: "0 12px"
	}
});

export default props => {

	const { UIStore } = useStores();
	UIStore.hideSponsorshipTopBar();
	UIStore.removeAdslotTapeta();

	useGlobalCSS({
		// "@mobile": {
		// 	'.adslot__ad-container[data-name$="_Billboard_1"]': {
		// 		marginBottom: "0"
		// 	},
		// 	".app-content": {
		// 		marginTop: "-33px"
		// 	},
		// },
		"@bp4": {
			'.adslot__ad-container[data-name$="_Billboard_1"]': {
				display: "none !important",
				height: "0 !important"
			},
			".app-content": {
				marginTop: "-84px"
			},
			".navigation-top--wrapper": {
				zIndex: 2,
				position: "relative"
			},
			".navigation-top--logo": {
				background: "transparent"
			},
			".navigation-top--second-line": {
				backgroundColor: "transparent"
			}
		}
	});

	const windowWidth = useWindowWidth();

	return (
		<>
			{windowWidth > 996 ?
				<Wrapper data-tb-region={props.blockSettings.tb_region}>
					<Box {...props}
						id="b1"
						type="BTextOnPicture"
						settings={props.settings.b1}
						imageHeight={750}
						size="lg"
						isOneSuper={true}
					/>
					<TrackEvent name="BOneSuper" category="ANALYTICS" label={window.location.href} />
				</Wrapper>
				:
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<Wrapper data-tb-region={props.blockSettings.tb_region}>
								<Box {...props}
									id="b1"
									type="BPhotoOnTop"
									settings={props.settings.b1}
									imageHeight={""}
									size="lg"
									isOneSuper={true}
								/>
								<TrackEvent name="BOneSuper" category="ANALYTICS" label={window.location.href} />
							</Wrapper>
						</div>
					</div>
				</div>
			}
		</>
	);
}
